import { desobfuscateUrl } from 'common/tools/seo/desobfuscation';
import trans from 'common/tools/translations/trans';

export default function getSharingConfiguration(videoData) {
  return {
    heading: trans('video-player.share-title'),
    link: desobfuscateUrl(videoData.mediaUrl),
    // Beware, JWP tries to decode this string as a URI component
    code: encodeURIComponent(getVideoEmbedCode(videoData)) // eslint-disable-line no-use-before-define
  };
}

export function getVideoEmbedCode(videoData, width = 480, height = 270) {
  return `<div id='blogvision'>
    <iframe src='${desobfuscateUrl(
      videoData.embedUrl
    )}' style='width:${width}px; height:${height}px'>
    </iframe>
    <br />
    <a href="${desobfuscateUrl(
      videoData.relatedEntityUrl
    )}" target="_blank" rel="noopener noreferrer">${
      videoData.relatedEntityTitle
    }</a>
    <br/>
    <a href="${desobfuscateUrl(videoData.mediaUrl)}">${
      videoData.description
    }</a>
  </div>`;
}
